module.exports = __webpack_public_path__ + "img/popularity-unchecked-en.90d49c97.png";